import { RouteObject } from "react-router";

const routeFiles = [
    require('@Modules/Auth/routes'),
    require('@Modules/CMS/Blog/Post/routes'),
    require('@Modules/CMS/Blog/Tag/routes'),
    require('@Modules/Dashboard/routes'),
];

const routes: RouteObject[] = [];

for (const routeFile of routeFiles) {
    routes.push(routeFile.default);
}

export default routes;
